/**
 * Enduser fields holding references to other records. Their raw values are IDs, so they need a
 * resolving cell rather than the generic value renderer, which would surface the IDs to the user.
 */
export type ReferenceField = "assignedTo" | "journeys" | "customTypeId" | "relationships";

const REFERENCE_FIELDS: Record<ReferenceField, true> = {
  assignedTo: true,
  journeys: true,
  customTypeId: true,
  relationships: true,
};

export const isReferenceField = (field: string): field is ReferenceField => field in REFERENCE_FIELDS;
